import React from "react";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../common/hooks/hooks";
import { setOnSale } from "../../../productSlice";
import { RootState } from "../../../../../../app/store";

const OnSaleFilter: React.FC<{ idPrefix: string }> = ({ idPrefix }) => {
  const dispatch = useAppDispatch();
  const { t, ready: areTranslationsReady } = useTranslation();

  const isOnSale = useAppSelector(
    (state: RootState) => state.product.filters.onSale
  );

  const handleToggle = () => {
    // Dispatch the opposite of the current state
    dispatch(setOnSale(!isOnSale));
  };

  const isComponentLoading = !areTranslationsReady;
  const toggleId = `${idPrefix}on-sale-toggle`;

  return (
    <div className="filter-widget on-sale-filter">
      {isComponentLoading ? (
        <div style={{ padding: "0.5rem 0" }}>
          <Skeleton width="80%" height={24} />
        </div>
      ) : (
        <label
          htmlFor={toggleId}
          className={`filter-widget__label ${isOnSale ? "is-active" : ""}`}
          style={{ padding: 0 }}
        >
          <input
            type="checkbox"
            id={toggleId}
            className="filter-widget__checkbox"
            checked={isOnSale}
            onChange={handleToggle}
          />
          <span className="filter-widget__name">
            {t(
              "productsArchive.sidebar.onSaleLabel",
              "Only display on sale items"
            )}
          </span>
        </label>
      )}
    </div>
  );
};

export default OnSaleFilter;
